import lookUp from "../LookUp";
import systemConfig from "../SystemConfig";
import goodsType from "../GoodsType";
import compy from "../Compy";
import versionControl from "../VersionControl";
/**
 *基础数据路由
 */
const System = [
    {
        name: '系统快码',
        path: '/system/lookUp',
        component: lookUp
    },
    {
        name: '系统配置',
        path: '/system/systemConfig',
        component: systemConfig
    },
    {
        name: '货物类别配置',
        path: '/system/goodsType',
        component: goodsType
    },
    {
        name: '工商信息管理',
        path: '/system/compy',
        component: compy
    },
    {
        name: '版本控制',
        path: '/system/versionControl',
        component: versionControl
    },
];
export default System
